import { useSite } from '../context/SiteContext';
import useSEO from '../hooks/useSEO';
import { Kicker, Reveal } from '../components/Reveal';

export default function Legal({ type }) {
  const { lang, t, routeKey } = useSite();
  const data = t.legal[type];
  useSEO(t.meta[type], routeKey, lang);

  return (
    <div data-testid={`legal-${type}`}>
      <section className="mx-auto max-w-[1600px] px-5 pb-24 pt-40 sm:px-8 sm:pt-48">
        <Kicker>F&L Group</Kicker>
        <h1 className="mt-6 font-heading text-4xl font-black uppercase tracking-tight sm:text-6xl">
          {data.title}
        </h1>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-zinc-500">{data.updated}</p>

        <div className="mt-14 max-w-3xl space-y-10">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.04}>
              <h2 className="font-heading text-lg font-bold uppercase tracking-wide brand-text">{s.h}</h2>
              <p className="mt-3 leading-relaxed text-zinc-400">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
